<template>
  <table-view ref="table" class="h-full"
    :get-params-detalle="getParamsDetalle"
    :get-detalle="getDetalle"
    :get-pag="getPag"
    :get-excel="getExcel"
    :get-params="getParamsAux"
    :disable-routes="disableRoutes"
    :normalize-data="normalizeData"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    :excel-name="excelName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :vuexnamespace="vuexnamespace"
    :pag-response-path="pagResponsePath"
    :payload-single-id="PayloadSingleId"
    :breadcrumbs="breadcrumbs" />
</template>

<script>
import { i18n } from '@/i18n'
import { isAssignableTo } from '@/services/functions/isAssignableTo'
import getNestedValue from '@/services/functions/getNestedValue'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/HistoricalGenericFilter.vue'

class BreadCrumb {
  /** @type {string?} */ url = '';
  /** @type {string?} */ name = '';
  /** @type {string[]?} */ paths;
  /** @type {string} */ separator = ' ';
  /** @type {string?} */ getter = '';
  /** @type {string?} */ setter = '';
  /** @type {boolean} */ forceDynamic = true;
  /** @type {Function} */ routeCallback = (data, breadcrumb) => ({ path: this.url, name: data });
  /** @type {Function} */ dataCallback = (entity, breadcrumb) => (this.name ? this.name : this.paths?.map(path => getNestedValue(path, entity)).join(this.separator)) || '';
}

export default {
  name: 'list-generic-historical',
  components: {
    TableView
  },
  props: {
    getDetalle: {
      type: Function,
      required: true,
    },
    getPag: {
      type: Function,
      required: true,
    },
    getExcel: {
      type: Function,
      required: true,
    },
    getParams: {
      type: Function,
      required: true,
    },
    getParamsDetalle: {
      type: Function,
      required: true,
    },
    disableRoutes: {
      type: Function,
    },
    detailResponsePath: {
      type: String,
      default: ''
    },
    idVista: Number,
    vuexnamespace: String,
    excelName: String,
    headerUrl: String,
    breadcrumbs: {
      type: Array,
      required: true,
      validator: value => value.every(x => isAssignableTo(x, BreadCrumb))
    }
  },
  data () {
    return {
      FilterPanel: CustomFilter,
      headerTitle: i18n.t('historical.entity_name'),
      headerIcon: 'config',
      routeName: 'configurations/clients/webhooks/detail',
      pagResponsePath: 'listaEventos',
      PayloadSingleId: 'idevento',
    }
  },
  methods: {
    getParamsAux: function (data) {
      return {
        evento: data.evento ? data.evento.value : null,  
        fechaDesde: data.fechaDesde ? data.fechaDesde.value : null,  
        fechaHasta: data.fechaHasta ? data.fechaHasta.value : null,  
        mensaje: data.mensaje ? data.mensaje.value : null,  
        ...this.getParams(data)
      }
    },
    normalizeData: function (data = []) {
      return data.map(item => {
        item.evento = item.evento.replaceAll('_', ' ')
        item.mensaje = item.mensaje.replaceAll('_', ' ')
        return item
      })
    }
  },
}
</script>

<style scoped>

</style>
